import React, {useState} from 'react';
import * as R from 'ramda';
import { useDispatch } from 'react-redux';
import {FileTypes} from '../../constants/utils/fileTypes';
import $ from 'jquery';
import { deleteDocument} from '../../actions/user-api';
import { deleteDocument as facilitaDeleteDocument} from '../../actions/facilita-api';

export const ModalDelete = ({ userId, elementToDelete, currentPath, onFileDelete, isFacilita }) => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    if(R.isNil(isFacilita)){
        isFacilita = false;
    }
    if(R.isNil(elementToDelete)){
        return "";
    }
	return (
		<div className="modal fade px-0" id="deleteDoc" aria-labelledby="deleteDocLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<div className="modal-header">
						<div className="alert bg-alert-danger rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Supprimer</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 font-weight-demi text-danger text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="infoValiderLabel">Supprimer</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</div>
					<div className="modal-body text-center">
						{/* <div className="h2 lh-copy">Supprimer le fichier?</div> */}
						<div className="fs-sm ls-n1 o-80">Etes-vous sûr(e) de vouloir supprimer le {elementToDelete.fileType === FileTypes.Folder ? "dossier" : "fichier"} <strong>"{R.isNil(elementToDelete) ? '' : elementToDelete.fileName}"</strong>?</div>
						<div className="fs-3 o-80 text-danger"><b className="font-weight-black">AVERTISSEMENT</b>: Cette action est irréversible.</div>
					</div>
					<div className="modal-footer justify-content-center gap-2">
						<button type="button" className="btn btn-light" data-dismiss="modal" aria-label="Close">Annuler</button>
						<button type="button" className={"btn btn-danger loading-btn" + (isLoading ? " show" : "")} onClick={(e) => {
                            setIsLoading(true);
                            let fileName = elementToDelete.fileName;
                            let path = currentPath;
                            if(elementToDelete.fileType === FileTypes.Folder)
                            {
                                fileName = "Folder";
                                path = (R.isNil(path) ? "" : path) + "/" + elementToDelete.fileName
                            }else if(elementToDelete.fileType !== FileTypes.Other){
                                path = undefined;
                            }
                            if(isFacilita){
                                dispatch(facilitaDeleteDocument(userId, fileName, path))
                                .then((deletedfileName) => {
                                    onFileDelete(deletedfileName);
                                    setIsLoading(false);
                                    $('.modal').modal("hide");
                                });
                            }else{
                                dispatch(deleteDocument(userId, fileName, path))
                                .then((deletedfileName) => {
                                    onFileDelete(deletedfileName);
                                    setIsLoading(false);
                                    $('.modal').modal("hide");
                                }); 
                            }                       
                        }}><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div> Oui, supprimer</button>
					</div>
				</div>
			</div>
		</div>
	);
}